import React, { Component } from 'react';
import withRouter from '../../components/withRouter';
import { Button } from 'react-bootstrap';
import styles from '../../../styles/frontend/Header.module.css';
import logo from '../../../assets/img/Logo-th.png';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { isMenuOpen: false };
  }

  handleNavigate = (path) => {
    this.setState({ isMenuOpen: false }); // ปิดเมนูเมื่อเปลี่ยนหน้า
    this.props.navigate(path);
  };

  toggleMenu = () => {
    this.setState((prev) => ({ isMenuOpen: !prev.isMenuOpen }));
  };

  render() {
    const { isMenuOpen } = this.state;

    return (
      <div className={styles.container}>
        {/* ---------------- Navbar Row ---------------- */}
        <div className={styles.navBar}>
          {/* Hamburger (mobile only) */}
          <div className={styles.hamburger} onClick={this.toggleMenu}>
            <i className="fa-solid fa-bars"></i>
          </div>

          {/* Nav Links (desktop only) */}
          <div className={styles.navLinks}>
            <div
              className={styles.navItem}
              onClick={() => this.handleNavigate('/homepage')}
            >
              <img
                src="/images/img_home2.svg"
                alt="Home"
                className={`me-4 ${styles.profileImage}`}
              />
              <span className={styles.navText}>หน้าหลัก</span>
            </div>

            <span
              className={`${styles.navText} ${styles.navItem}`}
              onClick={() => this.handleNavigate('/data-center')}
            >
              EEC Model
            </span>

            <span
              className={`${styles.navText} ${styles.navItem}`}
              onClick={() => this.handleNavigate('/publicize')}
            >
              ประชาสัมพันธ์
            </span>
          </div>

          {/* Logo Center */}
          <img
            // src="/images/img_easterneconomiccorridorlogowsvg_1.png"
            src={logo}
            alt="EEC Logo"
            className={styles.logo}
            style={{ maxWidth: "180px", width: "100%", height: "auto", padding: "18px" }}
            onClick={() => this.handleNavigate('/homepage')}
          />

          {/* Button Group (desktop only) */}
          <div className={styles.buttonGroup}>
            <Button
              className="view-all-btn d-flex align-items-center gap-2"
              onClick={() => this.handleNavigate('/external-users')}
              style={{
                minWidth: '160px',
                backgroundColor: '#ffffff',
                border: '1px solid #ccc',
                color: '#000',
              }}
            >
              <i className="fa-light fa-user" />
              เข้าสู่ระบบ
            </Button>

            <Button
              className="view-all-btn d-flex align-items-center gap-2"
              onClick={() => this.handleNavigate('/register')}
              style={{
                minWidth: '160px',
                // backgroundColor: '#0E3362',
                backgroundColor: '#ff9504',
                border: 'none',
                color: 'white',
              }}
            >
              <i className="fa-light fa-user-plus" />
              สร้างบัญชีผู้ใช้
            </Button>
          </div>
        </div>

        {/* ---------------- Mobile Dropdown Menu ---------------- */}
        <div
          className={`${styles.mobileMenu} ${isMenuOpen ? styles.open : ''}`}
        >
          <div
            className={styles.mobileItem}
            onClick={() => this.handleNavigate('/homepage')}
          >
            หน้าหลัก
          </div>
          <div
            className={styles.mobileItem}
            onClick={() => this.handleNavigate('/data-center')}
          >
            EEC Model
          </div>
          <div
            className={styles.mobileItem}
            onClick={() => this.handleNavigate('/publicize')}
          >
            ประชาสัมพันธ์
          </div>

          <div className={styles.mobileDivider}></div>

          <div
            className={styles.mobileItem}
            onClick={() => this.handleNavigate('/external-users')}
          >
            <i className="fa-light fa-user me-2" />
            เข้าสู่ระบบ
          </div>

          <div
            className={styles.mobileItem}
            onClick={() => this.handleNavigate('/register')}
          >
            <i className="fa-light fa-user-plus me-2" />
            สร้างบัญชีผู้ใช้
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Header);
